import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import moment from 'moment';


const mapLineToApiLineDto = (values: IEditLineForm, id: number): IPostEditLine | {} => {
  let dataMapping: IPostEditLine;
  const unknown = -1;

    dataMapping = {
      id: id,
      applProtocolNumber: values.applProtocolNumber,
      applDate: values.applDate ? `${moment(values.applDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null ,
      offApplDate: values.offApplDate ? `${moment(values.offApplDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null  ,
      deliveryDate: values.deliveryDate ? `${moment(values.deliveryDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null  ,
      pendingStatusID: +values.pendingStatusID !== 0 ? +values.pendingStatusID : null ,
      providerID: +values.providerID !== 0 ? +values.providerID : unknown,
      lineTypeID: +values.lineTypeID !== 0 ? +values.lineTypeID : unknown,
      comments: values.comments,
      usedByID: +values.usedByID !== 0 ? +values.usedByID : null,
      sapCode: values.sapCode,
      isEmporiki: values.isEmporiki,
      isCiti: values.isCiti,
      lineType: 2,
      costByID: +values.costByID !== 0 ? +values.costByID : unknown,
      speedID: +values.speedID !== 0 ? +values.speedID : unknown,
      cost: +values.cost !== 0 ? +values.cost : 0,
      endAUnitID: +values.endAUnitID,
      endBUnitID: +values.endBUnitID !== 0 ? +values.endBUnitID : unknown,
      hcNmsNum: values.hcNmsNum,
      hcNum1: values.hcNum1,
      hcNum2: values.hcNum2,
      accNum1: values.accNum1,
      accNum2: values.accNum2,
      coupleNumA1: values.coupleNumA1,
      coupleNumB1: values.coupleNumB1,
      coupleNumA2: values.coupleNumA2,
      coupleNumB2: values.coupleNumB2,
      phoneNumber: values.phoneNumber,
      descline: values.descline,
      removalDate: values.removalDate ? `${moment(values.removalDate).format('YYYY-MM-DDTHH:mm:ss.SSS')}Z` : null ,
      CDLineType: values.CDLineType,
      CDAddressA: values.CDAddressA,
      CDAddressB: values.CDAddressB,
      removalComment: values.removalComment,
    }
  
  return dataMapping;
}


const editLine = ( {data, lineId} : {data: IEditLineForm , lineId: number}): Promise<string> => {
  const line = mapLineToApiLineDto(data, lineId);
  console.log(JSON.stringify(line))
  return axiosDefaultApi.put(`/api/ComLines/UpdateComLine`, line);
};

type QueryFnType = typeof editLine;

type UseEditLineOptions = {
  data: IPostEditLine | {};
  lineId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditLine = ({ config }: UseEditLineOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Γραμμής Data.`, 500);
            console.error('Couldnt edit Line', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllLines"])
            addNotification('Η Γραμμή Data Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editLine,
    })
}